import { useLanguage } from "@/contexts/LanguageContext";

const painPoints = [
  { key: "messages" },
  { key: "calling" },
  { key: "lostOrders" },
  { key: "noStatus" },
];

export function PainRecognitionSection() {
  const { t } = useLanguage();

  return (
    <section className="bg-muted py-10 sm:py-12">
      <div className="max-w-3xl mx-auto px-4">
        <h2 className="text-lg sm:text-xl font-bold text-foreground mb-6 tracking-tight">
          {t("landing.pain.headline")}
        </h2>
        
        {/* Stacked list - no icons, brutalist */}
        <div className="space-y-2">
          {painPoints.map((pain, index) => (
            <div
              key={pain.key}
              className="flex items-start gap-3 py-3 border-b border-border/30 last:border-b-0"
            >
              <span className="text-xs font-mono-display text-muted-foreground mt-0.5">
                {String(index + 1).padStart(2, '0')}
              </span>
              <span className="text-sm text-foreground">
                {t(`landing.pain.${pain.key}`)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
